import { Flex, Text, Box } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { FaBuilding } from "react-icons/fa";
import CardDefault from "../CardDefault";
import colors from "core/resources/theme/colors";

interface Card1HorizontalProps {
  title: string;
  description: string;
  onClick?: any;
  icon?: any;
  bg: string;
  color: string;
  iconWidth?: string;
  loading?: boolean;
  right?: any;
  w?: string;
  h?: string;
  selected?: boolean;
  fontSize?: number;
  descriptionFontSize?: number;
  topIcon?: React.ReactNode;
}

function Card1Horizontal({
  title,
  description,
  onClick,
  icon,
  bg,
  color,
  iconWidth,
  loading,
  right,
  w,
  h = "100%",
  selected,
  fontSize = 22,
  descriptionFontSize = 12,
  topIcon,
}: Card1HorizontalProps) {
  return (
    <CardDefault
      flexDir="row"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
      h={h}
      w={w}
      position="relative"
      borderWidth={selected ? 2 : 0}
      borderColor={colors.primary}
    >
      {loading ? (
        <Skeleton h={66} flex={1} w="100%" />
      ) : (
        <>
          <Flex w={iconWidth ?? undefined}>
            <Flex
              w="40px"
              h="40px"
              rounded="50%"
              justifyContent="center"
              alignItems="center"
              bg={bg}
            >
              {!icon ? <FaBuilding fontSize="18px" color={color} /> : icon}
            </Flex>
          </Flex>
          <Flex pl="14px" flex={1} justifyContent="center" flexDir="column">
            <Text fontSize={fontSize} fontWeight="bold">
              {title}
            </Text>
            <Text fontSize={descriptionFontSize}>{description}</Text>
          </Flex>
          {right ? (
            <Flex px="16px" alignItems="center" justifyContent="center">
              {right}
            </Flex>
          ) : null}
        </>
      )}
      {topIcon ? (
        <Box position="absolute" top={2} right={2}>
          {topIcon}
        </Box>
      ) : null}
    </CardDefault>
  );
}

export default Card1Horizontal;
